import { render, staticRenderFns } from "./BottomInfoNav.vue?vue&type=template&id=1096896e&scoped=true&"
import script from "./BottomInfoNav.vue?vue&type=script&lang=js&"
export * from "./BottomInfoNav.vue?vue&type=script&lang=js&"
import style0 from "./BottomInfoNav.vue?vue&type=style&index=0&id=1096896e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1096896e",
  null
  
)

/* custom blocks */
import block0 from "@/locales/parts/footer/BottomInfoNav.json?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cparts%5Cfooter%5CBottomInfoNav.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports